import { ErrorMessage } from "./ErrorMessage";

const Error404 = () => {
  return (
    <ErrorMessage
      title="Not Found"
      description="This page does not exist. Please use the sidebar to go back to a known page."
      showBackButton
    />
  );
};

export { Error404 };
export default Error404;
